export const errorMessageSelector = (error, defaultMessage) => {
    if (error === null || error === void 0 ? void 0 : error.message) {
        return error.message;
    }
    if (error === null || error === void 0 ? void 0 : error.title) {
        return error.title;
    }
    return defaultMessage || 'Something went wrong. Please try again.';
};
